<template>
    <div class="field pdf_field_wrapper" :class="modelValue ? 'is-filled' : ''">
        <div class="info_wrapper">
            <label class="pdf_label" :class="isRequired ? 'req': ''" v-html="label"></label>
            <p class="field_description" v-if="description" v-html="description"></p>
            <div class="dz-error-message-scenario" style="color:red; margin-bottom: 20px;"></div>
        </div>
        <form :id="objectKey" :action="getUploadPath" class="dropzone">
            <div class="pdf_file_info" v-if="modelValue">
                <p class="file_name">{{ modelValue }}</p>
            </div>
            <div class="pdf_info_block" v-if="modelValue">
                <p class="downloaded-text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                        <path d="M8.00216 0C3.58196 0 0 3.58196 0 8.00648C0 12.4267 3.58196 16.0043 8.00216 16.0043C12.4224 16.0043 16 12.4267 16 8.00648C16 3.58196 12.4224 0 8.00216 0ZM12.4137 6.23062L6.68431 11.9255L3.59492 8.90953C3.19309 8.51634 3.18877 7.87254 3.58196 7.46638C3.97516 7.06454 4.62328 7.0559 5.02512 7.45342L6.67135 9.06508L10.9792 4.77883C11.3767 4.38131 12.0205 4.38131 12.418 4.78315C12.8199 5.18499 12.8112 5.82879 12.4137 6.23062Z"
                              fill="#6EE76E"/>
                    </svg>
                    <span>Документ загружен</span></p>
                <p><a class="pdf_scenario" target="_blank" :href="resultLink">Ссылка на скачивание <i
                        class="fas fa-link"></i></a></p>
                <p v-if="getResultDeletePath !== undefined"><a class="pdf_delete_link" @click="deleteItem()">Удалить</a>
                </p>
            </div>
        </form>
				<p class="upload_description">В формате PDF, макс. 20 мегабайт. При наличии нескольких страниц, необходимо сформировать их в один PDF документ.</p>
    </div>
</template>

<script>
import Dropzone from "dropzone";
import 'dropzone/dist/dropzone.css';
import axios from "axios";

export default {
  name: "BasePdfUploader",
  data() {
    return {
      fileSize: '',
      prod_url: 'https://cdn.moviestart.ru',
      dev_url: 'https://storage.yandexcloud.net/scriptcdn-dev',
    }
  },
  props: {
    'description': {},
    'label': {},
		//Имя.расширение загруженного файла (без пути к нему). v-model где это хранится в родительском компоненте
		modelValue: {
      required: true,
      type: String
		},
		//Адрес на бэкенде, куда будет отправлен pdf файл для загрузки
    'pathToUpload': {
      required: true,
      type: String,
			default: '/upload_pdf_document'
		},
    //Адрес на бэкенде, для удаления загруженного файла
    'pathToDelete': {
      required: true,
      type: String,
      default: '/remove_pdf_document'
		},
		//Будет названием папки в public/uploads/pdf и ключом в json объекте в базе данных
    'objectKey': {
      required: true,
			type: String
		},
		//Нужно только, чтобы показать звездочку обязательности. Вся валидации в родительском компоненте
    'isRequired': {},
    'isNewLink': {}
  },
  components: {},
  async mounted() {
    await this.checkIsLinkValid();


    //https://docs.dropzone.dev/configuration/basics/configuration-options
    const myDropzone = new Dropzone("#" + this.objectKey, {
      maxFiles: 1,
      dictDefaultMessage: "Кликните здесь, чтобы выбрать файл для загрузки или перетащите файл сюда.",
      acceptedFiles: 'application/pdf',
      paramName: this.objectKey,
    })
    const self = this;

    myDropzone.on("sending", function (file, xhr, formData) {
      formData.append('exist_file_name', self.modelValue);
    });

    myDropzone.on("success", function (file, response) {
      self.$emit('update:modelValue', response);
      self.$emit('onChange');
    });

    myDropzone.on("error", function (file, errorMessage) {
      // Выполните здесь необходимые действия при возникновении ошибки загрузки файла
      console.error("Произошла ошибка при загрузке файла:", errorMessage);
      self.$emit('onError', errorMessage); // Пример события для передачи сообщения об ошибке компоненту Vue
    });

    //this.getFileSize();
  },
  methods: {
    async checkIsLinkValid() {
      if (this.isNewLink && window.APP_ENV === 'dev') {
        const response = await axios.post('/is_yandex_link_valid', null, {
          params: {
            yandex_link: this.resultLink
          }
        })
        if (!response.data) {
          this.resultLink.replace(this.dev_url,this.prod_url);
        }
      }
		},
    async deleteItem() {

      await axios.post(this.getResultDeletePath, null, {
        params: {
          exist_file_name: this.modelValue,
					entity_name: this.objectKey
        }
      });
      this.$emit('update:modelValue', '');
      this.$emit('onChange');
    },
    async getFileSize() {
      if (this.value) {
        const response = await axios.post('/get_file_size_by_link', null, {
          params: {
            link: this.resultLink
          }
        })
        this.fileSize = response.data;
      }
    },
  },
  computed: {
    //Формируем ссылку на скачивание файла
    resultLink() {
      return this.getResultPath + '' + this.modelValue
    },
    getUploadPath() {
      return this.pathToUpload;
    },
    getResultDeletePath() {
      return this.pathToDelete;
    },
    getResultPath() {
      let res = '/uploads/pdf/' + this.objectKey + '/';

      if (this.isNewLink) {
        let basePath = this.prod_url + '' + res;
        if (window.APP_ENV === 'dev') {
          basePath = this.dev_url + '' + res;
        }
        return basePath;
      }

      return res;
		},
  },
	watch: {
    async modelValue() {
      await this.checkIsLinkValid();
		}
	}
}
</script>

<style scoped>
.field_description {
    font-size: 16px;
}
.pdf_field_wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
}
.info_wrapper {
		flex-grow: 1;
}

.downloaded-text {
    margin-top: 15px;
    display: flex;
    align-items: center;
}

.downloaded-text svg {
    margin-right: 10px;
    margin-top: 4px;
}

.pdf_scenario {
    color: #222;
    text-decoration: underline;
}

.pdf_scenario i {
    margin-left: 10px;
}

.pdf_delete_link {
    color: #222;
    text-decoration: underline;
}

.pdf_info_block {
}

.pdf_file_info {
    border-radius: 8px;
    background: linear-gradient(180deg, #EFA24F 0%, #E48722 100%);
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
    width: 160px;
    height: 100px;
    padding: 7px;
    margin-right: 25px;
}

.pdf_file_info .file_name {
    padding: 5px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.50);
}
/*.pdf_label {*/
/*    font-weight: 700;*/
/*}*/
.upload_description {
    margin-top: 20px;
    font-size: 16px;
}
@media (max-width: 1000px) {
    .field.is-filled .dropzone {
			flex-direction: column;
		}
}
</style>